import { useTranslation } from 'react-i18next'

import styled from 'styled-components'

const List = styled.ul`
  margin-left: 2rem;
`

export default function DbList() {
  const { t } = useTranslation()

  return (
    <List>
      {t('home.database.list', { returnObjects: true }).map((item) => (
        <li key={item}>{item}</li>
      ))}
    </List>
  )
}
